import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import { pressQuotes } from "../data/press";
import { festival } from "../data/festival";
import { IconExternal } from "../components/icons";
import styles from "./Press.module.css";

const aboutSubNav = [
  { label: "About", path: "/about", end: true },
  { label: "Venue Info", path: "/about/venue" },
  { label: "FAQ", path: "/about/faq" },
  { label: "SFMA", path: "/about/sfma" },
  { label: "Press", path: "/about/press" },
  { label: "Contact", path: "/about/contact" },
];

export default function Press() {
  return (
    <>
      <PageHero
        eyebrow="In the press"
        title="Press"
        lede="What people have written about Rhythms on the Rio. For interview requests and review credentials, write us."
        image="/photos/festival-3.jpg"
      />
      <SubNav items={aboutSubNav} />

      <Page>
        <div className={styles.contactBar}>
          <div>
            <h3 className={styles.h}>Press inquiries</h3>
            <p className={styles.body}>
              Photo passes, interview requests, asset packs.
            </p>
          </div>
          <a className={styles.contactLink} href={`mailto:${festival.emailPress}`}>
            {festival.emailPress}
          </a>
        </div>

        <ul className={styles.list}>
          {pressQuotes.map((p) => (
            <li key={p.headline} className={styles.item}>
              <a href={p.href} target="_blank" rel="noopener" className={styles.cardLink}>
                <span className={styles.pub}>{p.publication}</span>
                <h3 className={styles.headline}>{p.headline}</h3>
                {p.quote && <p className={styles.quote}>“{p.quote}”</p>}
                <span className={styles.read}>
                  Read article <IconExternal />
                </span>
              </a>
            </li>
          ))}
        </ul>
      </Page>
    </>
  );
}
